import React from "react";

import "./LeftLabelTextInput.css";

export const LeftLabelTextInput = ({labelText, defaultValue, handleChange, disabled}) => {

    return (
        <div className="left-label-text-input-container">
            <label>{labelText}</label>
            <input data-testid="test-input" type="text" defaultValue={defaultValue} onChange={handleChange} disabled={disabled}/>
        </div>
    );
}
